import React, { useContext } from 'react'
import Step from 'app/React/Components/Header/TopNavigation/Step'
import StepIsValid from 'app/React/Components/misc/StepIsValid'
import { stepIsActive, stepExists } from 'app/React/Helpers/StepHelper'
import { getStepInfo } from 'utils/getStepInfo'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer"

export default function TopNavigation(props) {
  const {
    currentStep,
    isMenuOpen,
    colorSettingId,
    currentEngineTransmission,
    currentVariant,
    order,
    setCurrentStep,
    setIsAccessoryShopOpen,
    setIsMenuOpen
  } = useContext(ConfiguratorContext)

  const changeStep = function (step_id) {
    if (step_id == 4) {
      setIsAccessoryShopOpen(false)
    }

    if (stepExists(currentVariant.steps, step_id)) {
      setCurrentStep(step_id)
    }

    setIsMenuOpen(false)
    // TODO: Make change step validate and make function global for use in footer
  }

  const step_elements = Object.keys(currentVariant.steps)
    .filter((key, index) => {
      // Only check for step 2,3,4, because they can have no active settings, based on payment type.
      if ([2, 3, 4].includes(currentVariant.steps[key]?.step_id) && !stepIsActive(
        currentVariant.steps[key].settings,
        currentVariant.steps[key]?.step_id,
        colorSettingId,
        currentEngineTransmission,
        currentVariant,
        order
      )) {
        return false // There is no active settings
      }

      return true
    })
    .map((key, index) => {
      // noinspection EqualityComparisonWithCoercionJS
      return (
        <StepIsValid key={key} step={index === 0 ? null : currentVariant.steps[Object.keys(currentVariant.steps)[index - 1]].step_id}>
          <Step
            index={index + 1}
            step={currentVariant.steps[key]}
            onClick={changeStep}
            active={currentStep == getStepInfo(currentVariant.steps, key).step_id}
          />
        </StepIsValid>
      )
    })

  const classList = [isMenuOpen ? 'open' : null, 'top-navigation']

  return <div className={classList.join(' ')}>{step_elements}</div>
}
